import { API_SVC_BASE_URL, FRONT_END_VERSION } from "./Config";
export var baseHeaders = process.env.REACT_APP_ORIGIN === 'mi' ? new Headers({
    'ui-origin': 'mi',
    'x-mi-anticsrf': '-'
}) : new Headers({
    'ui-origin': 'hcr',
    'x-mi-anticsrf': '-'
});
var jsonHeaders = process.env.REACT_APP_ORIGIN === 'mi' ? new Headers({
    'ui-origin': 'mi',
    'content-type': 'application/json',
    'x-mi-anticsrf': '-'
}) :
    new Headers({
        'ui-origin': 'hcr',
        'content-type': 'application/json',
        'x-mi-anticsrf': '-'
    });
export var fetchWrapper = function (path, options) {
    return fetch(path, options)
        .then(function (resp) {
        var value = resp.headers.get('x-mi-version');
        if (value !== null) {
            var num = parseInt(value, 10);
            if (!isNaN(num) && FRONT_END_VERSION < num) {
                var warning = document.getElementById('mi-front-end-version-outdated');
                if (warning !== null && !warning.classList.contains('active')) {
                    warning.classList.add('active');
                }
            }
        }
        return Promise.resolve(resp);
    });
};
export var getNoAuthn = function (path) {
    return fetchWrapper(API_SVC_BASE_URL + path, {
        headers: baseHeaders
    });
};
export var getWithAuthn = function (path) {
    return fetchWrapper(API_SVC_BASE_URL + path, {
        headers: baseHeaders,
        credentials: 'include'
    });
};
export var postWithAuthn = function (path, body) {
    return fetchWrapper(API_SVC_BASE_URL + path, {
        headers: baseHeaders,
        method: 'POST',
        credentials: "include",
        body: body
    });
};
export var postJsonWithAuthn = function (path, json) {
    return fetchWrapper(API_SVC_BASE_URL + path, {
        headers: jsonHeaders,
        method: 'POST',
        credentials: "include",
        body: json
    });
};
export var postJsonNoAuthn = function (path, json) {
    return fetchWrapper(API_SVC_BASE_URL + path, {
        headers: jsonHeaders,
        method: 'POST',
        body: json
    });
};
export var deleteWithAuthn = function (path) {
    return fetchWrapper(API_SVC_BASE_URL + path, {
        headers: baseHeaders,
        method: 'DELETE',
        credentials: "include"
    });
};
export var CatalogMode;
(function (CatalogMode) {
    CatalogMode[CatalogMode["Consumer"] = 0] = "Consumer";
    CatalogMode[CatalogMode["Internal"] = 1] = "Internal";
})(CatalogMode || (CatalogMode = {}));
//# sourceMappingURL=RequestHelpers.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/RequestHelpers.js
// module id = 6
// module chunks = 0